import "core-js/modules/es6.function.name";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import RatingStars from '~/components/molecules/Global/RatingStars.vue';
export default {
  name: 'MerchantReinsurance',
  components: {
    RatingStars: RatingStars
  },
  props: {
    merchant: {
      type: Object,
      required: true
    },
    isMarketplace: {
      type: Boolean,
      required: false
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    merchantUrl: function merchantUrl() {
      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/m/").concat(this.merchant.reference);
    }
  }),
  methods: {
    handleClickMerchant: function handleClickMerchant(event) {
      this.$root.$emit('generic-tracking', event, {
        fn: 'track-event',
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_vendeur',
          event_label: this.merchant.name
        }
      });
    },
    handleClickRating: function handleClickRating(event) {
      this.$root.$emit('generic-tracking', event, {
        fn: 'track-event',
        data: {
          event_category: 'FicheProduit',
          event_action: 'Clic_avis_vendeur',
          event_label: this.merchant.name
        }
      });
    }
  }
};